export const ReceivedProductsColumns = {
  ACCEPT: 'accept',
  REJECT: 'reject',
  SKU: 'sku',
  INVENTORY_LOCATION_ID: 'inventoryLocationId',
  LOT: 'lot',
  COST: 'cost',
  TOTAL: 'total',
  UNIT_OF_MEASURE_ID: 'unitOfMeasureId',
} as const;
